export default __webpack_public_path__ + "static/media/Gmail_icon.svg.27f35c96.webp";